import { KarrotLocalCountryCode } from "@karrotmarket-com/core";
import type { Context } from "shared/defineContext";

export const verifyAdminUser = ({
  userNickname,
  stage,
  karrotLocalCountryCode,
}: {
  userNickname: string;
  stage: Context["stage"];
  karrotLocalCountryCode: KarrotLocalCountryCode;
}) => {
  if (karrotLocalCountryCode === KarrotLocalCountryCode.JP) {
    const isAdminUser =
      (stage === "prod" && userNickname === "キャロ") ||
      (stage === "alpha" && userNickname === "しぴ");

    return isAdminUser;
  }

  if (
    karrotLocalCountryCode === KarrotLocalCountryCode.CA ||
    karrotLocalCountryCode === KarrotLocalCountryCode.US ||
    karrotLocalCountryCode === KarrotLocalCountryCode.UK
  ) {
    const isAdminUser =
      (stage === "prod" && ["Karrot", "karrot"].includes(userNickname)) ||
      (stage === "alpha" && userNickname === "sophie");

    return isAdminUser;
  }

  return false;
};
